export const GET_PROMO_LIST_REQUEST = 'GET_PROMO_LIST_REQUEST';
export const GET_PROMO_LIST_SUCCESS = 'GET_PROMO_LIST_SUCCESS';
export const GET_PROMO_LIST_FAIL = 'GET_PROMO_LIST_FAIL';
export const GET_PROMO_DETAIL_REQUEST = 'GET_PROMO_DETAIL_REQUEST';
export const GET_PROMO_DETAIL_SUCCESS = 'GET_PROMO_DETAIL_SUCCESS';
export const GET_PROMO_DETAIL_FAIL = 'GET_PROMO_DETAIL_FAIL';
